import { useMediaQuery } from '@react-hook/media-query';
import variables from '../lib/css/variables.css';

export function useIsMobile() {
    return useMediaQuery(`screen and (max-width: ${variables.mediumDeviceMax})`);
}



// WEBPACK FOOTER //
// ./src/hooks/screenSizeHooks.js